import { useRef } from 'react';

import {
    useApprovedNotTakenOffers,
    useGetCustomerState
} from '@api/lendingAPI/lapiHooks';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Card } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import redQuarterCircleSvg from './redQuarterCircle.svg';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    applyForFlexi: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/apply-flexi-loan/', search: '?ipxsell=1' }
        } as const)
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const RawCrossSellCard = ({ applyForFlexi }: PropsFromRedux) => {
    const stateKey = useStateKey();
    const { data: customerState, isLoading: loadingCustomerState } =
        useGetCustomerState(stateKey);
    const { approvedNotTakenOffers, loadingApprovedNotTaken } =
        useApprovedNotTakenOffers();
    const hasTrackedView = useRef(false);
    const trackView = () => {
        if (hasTrackedView.current) return;
        hasTrackedView.current = true;

        tracking.ampli.buyerDisplayedXSellBanner();
    };

    const isSoleTrader =
        customerState?.application?.company?.type === 'sole_trader';

    if (loadingApprovedNotTaken || loadingCustomerState) return null;
    if (approvedNotTakenOffers && approvedNotTakenOffers.length > 0)
        return null;
    if (isSoleTrader) return null;

    trackView();

    const trackBannerClick = () => {
        tracking.ampli.buyerClickedXSellBanner();
    };

    return (
        <Card className="relative z-0 mb-xl overflow-hidden bg-primary-20">
            <div className="flex w-full items-center justify-between gap-s text-structure-100 max-sm:flex-col max-sm:gap-l">
                <div>
                    <h2 className="m-0 mb-xs text-xl font-bold">
                        Get a business loan with iwoca
                    </h2>
                    <p className="m-0 text-s font-reg">
                        Borrow £1,000 &ndash; £1,000,000 to buy new stock,
                        invest in growth plans or just keep your cash flow
                        smooth.
                    </p>
                </div>
                <div className="flex flex-col items-center gap-s max-sm:w-full">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            trackBannerClick();
                            applyForFlexi();
                        }}
                        id="applyForFlexi_INCLUDE"
                        className="z-10 w-full"
                    >
                        Apply now
                    </Button>
                    <p className="m-0 p-0 text-center text-xs font-med text-structure-100">
                        Applying won't affect your credit score
                    </p>
                </div>
            </div>
            <img
                src={redQuarterCircleSvg}
                alt=""
                className="absolute right-0 top-0 z-0 max-sm:w-2xl"
            ></img>
        </Card>
    );
};

export const CrossSellCard = connect(
    null,
    mapDispatchToProps
)(RawCrossSellCard);
